import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=ff1106ba&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.scss?vue&type=style&index=0&id=ff1106ba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1106ba",
  null
  
)

export default component.exports